/**
 * Purpose: Classroom theme definition — the base "Family Road Trip" visual skin.
 * Owns: All color token values for the premium chalkboard aesthetic.
 * Notes: These are solid placeholder colors per conventions.md section 3.
 *        Rich textures (chalkboard grain, wood, paper) will be layered via CSS later.
 *        Token names map directly to CSS custom properties (CS-22).
 */

import type { Theme } from '../types/theme';

/** The base classroom chalkboard theme — premium, warm, inviting. */
export const classroomTheme: Theme = {
  id: 'classroom',
  name: 'Classroom Chalkboard',
  colors: {
    bgChalkboard: '#2d4a3e',
    bgCard: '#f5f0e1',
    btnA: '#8b4049',
    btnB: '#b8860b',
    btnC: '#4a6741',
    btnD: '#4a5568',
    accentWood: '#6b4226',
    textLight: '#f5f0e1',
    textDark: '#2c2c2c',
    accentGold: '#d4a843',
    correct: '#4a6741',
    incorrect: '#8b4049',
    bgSurface: '#1e3a2f',
    muted: '#6b7280',
  },
  fontFamily: "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",
  fontFamilyDisplay: "'Permanent Marker', cursive",
  fontFamilyHandwriting: "'Patrick Hand', cursive",
};
